<layer-header (closeLayer)="closeLayer()"
              (setListView)="setListView($event)"
              [listToggle]="listToggle"
              [title]="'Conditions'">
    <ng-content></ng-content>
</layer-header>
<activity-condition-edit *ngIf="topLayer == 'edit'"
                         [serviceId]="serviceId"
                         [registration]="registration"
                         [determinantMapById]="determinantMapById"
                         [activityCondition]="activityCondition"
                         [registrationActivityCondition]="registrationActivityCondition"
                         [laws]="laws"
                         [activityConditionTypes]="activityConditionTypes"
                         (editCancel)="cancelEdit($event);"
                         (formSubmit)="submitEdit($event);"
                         class="row layer sub-layer px-3 pt-1">
</activity-condition-edit>
<div class="row">
    <div class="col-md-1">
    </div>
    <div class="col-lg-12 col-xl-11">
        <!-- Search -->
        <div class="row">
            <div class="col-md-12 col-xl-6">
                <div class="form-controller list-search-container">
                    <i class="fas fa-search list-search-icon"></i>
                    <input type="text"
                           [(ngModel)]="userFilter.name"
                           placeholder="{{ 'general.search' | translate }}"
                           class="form-control list-search-input flew-grow-1">
                    <button class="btn btn-sm btn-primary"
                       (click)="openEdit(false);$event.stopPropagation();"
                       placement="left"
                       aria-hidden="true">{{'Add' | translate}}</button>
                </div>
            </div>
        </div>
        <!-- Listing -->
        <div class="{{listToggle ? 'cards-list' : 'rows-list'}} row"
             style="margin-bottom:2rem">
            <div *ngFor="let activityCondition of activityConditions | filterBy: userFilter; let i = index"
                 class="nglist-item {{listToggle ? 'col-sm-6 col-md-4 col-lg-3' : 'col-md-12 col-xl-6'}}"
                 (click)="openEdit(activityCondition);$event.stopPropagation();">
                <div class="nglist-item-content">
                    <span class="nglist-item-content-title">
                      {{activityCondition.name}}
                    </span>
                </div>
                <div class="nglist-item-actions alternate">
                    <icon style="margin-inline-end:0.5rem;"
                          className="far fa-circle toggle__icon"
                          *ngIf="!isActive(activityCondition)"
                          (click)="saveRegistrationActivityCondition(activityCondition);$event.stopPropagation()"></icon>
                    <icon style="margin-inline-end: 0.5rem;color:#8ecb35;cursor:pointer"
                          className="fas fa-check icon-success"
                          *ngIf="isActive(activityCondition)"
                          (click)="deleteRegistrationActivityCondition(activityCondition);$event.stopPropagation()"></icon>
                    <confirmation [showTrashIcon]="true"
                                  [question]="'confirm.areyousure'"
                                  [extraClasses]="'nglist-item-action'"
                                  (click)="$event.stopPropagation()"
                                  (isConfirmed)="deleteActivityCondition($event, activityCondition)"></confirmation>
                </div>
            </div>
        </div>
    </div>
</div>